import React from "react";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import OtimizeSeuNegocio from "./OtimizeSeuNegocio";

export default function BusinessBeneficios({
    title = "",
    text = "",
    buttonText = "",
    buttonLink = "",
    buttonActionText = "",
    items = [],
}) {
    const { openModal } = useModal();

    return (
        <div className="w-full bg-[#040116] py-16 md:py-20 relative overflow-hidden">
            {/* Background com grafismos */}
            <div className="absolute inset-0 opacity-10 flex justify-end">
                <img
                    src="/assets/grafismos2.png"
                    alt="Grafismos"
                    className="h-full object-contain object-right-top"
                />
            </div>

            <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-4 relative z-10">
                {/* Coluna da esquerda - Título, descrição e botão */}
                <div className="lg:w-1/2 flex flex-col justify-center px-4 md:px-24 text-center lg:text-left">
                    <h2 className="text-white text-2xl md:text-6xl font-inter-bold mb-8 uppercase md:capitalize">
                        {title}
                    </h2>
                    <div className="text-white mb-10">
                        <p className="text-xl mb-4 leading-8">
                            <span className="">{text}</span>
                        </p>
                    </div>
                    <div className="flex flex-col hidden md:block">                        
                        <OtimizeSeuNegocio
                            type="solid"
                            text="Otimize seu negócio!"
                            buttonText="Contratar"
                            useFormularioRD={true}
                            className=""
                        />
                    </div>
                </div>

                {/* Coluna da direita - Lista de benefícios */}
                <div className="lg:w-1/2 grid grid-cols-1 gap-8 px-6 md:pl-12">
                    {items.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-row gap-6 md:gap-8"
                        >
                            <div className="relative">
                                {/* Purple blur effect behind the circle */}
                                <div
                                    className="absolute w-12 h-12 rounded-full bg-[#A002CB] blur-xl opacity-70"
                                    style={{ zIndex: 1 }}
                                ></div>
                                <div
                                    className="w-12 h-12 rounded-full bg-white flex items-center justify-center flex-shrink-0 relative"
                                    style={{ zIndex: 2 }}
                                >
                                    <img
                                        src={item.icon}
                                        alt={item.title}
                                        className="w-8 h-8 text-[#A002CB]"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <h3 className="text-[#A800E4] text-[15px] md:text-[20px] font-inter-bold mb-1">
                                    {item.title}
                                </h3>
                                <p className="text-xs md:text-base text-white font-inter-regular">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                    <div className="flex flex-col pt-4 block md:hidden">                        
                        <OtimizeSeuNegocio
                            type="solid"
                            text="Otimize seu negócio!"
                            buttonText="Contratar"
                            useFormularioRD={true}
                            className=""
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
